import request from "@/utils/request";

export function getAllGerminatedSeedTransaction(params) {
    return request({
        url: "/api/services/app/GerminatedSeedTransaction/GetAll",
        method: "GET",
        params
    });
}

export function getAllGerminatedSeedTransactionType() {
    return request({
        url: "/api/services/app/GerminatedSeedTransaction/GetAllTypesForDropDown",
        method: "GET"
    });
}

export function getGerminatedSeedTransactionDetail(params) {
    return request({
        url: "/api/services/app/GerminatedSeedTransaction/Get",
        method: "GET",
        params
    });
}


export function createTransaction(data) {
    return request({
        url: "/api/services/app/GerminatedSeedTransaction/Create",
        method: "POST",
        data
    });
}

export function createManyTransaction(data) {
    return request({
        url: "/api/services/app/GerminatedSeedTransaction/CreateMany",
        method: "POST",
        data
    });
}

export function updateTransaction(data) {
    return request({
        url: "/api/services/app/GerminatedSeedTransaction/Update",
        method: "PUT",
        data
    });
}


export function deleteTransaction(params) {
    return request({
        url: "/api/services/app/GerminatedSeedTransaction/Delete",
        method: "DELETE",
        params
    });
}

export function deleteManyTransaction(data) {
    return request({
        url: "/api/services/app/GerminatedSeedTransaction/DeleteMany",
        method: "POST",
        data
    });
}

export function getFilterInfo(params) {
    return request({
        url: "/api/services/app/GerminatedSeedTransaction/GetFilterInfo",
        method: "GET",
        params
    });
}


// WEBPACK FOOTER //
// ./src/api/germinated_seed_transaction.js